// Global error handler to suppress harmless ResizeObserver errors
// This is a known issue with MUI DataGrid and other components that use ResizeObserver
// The error is harmless and doesn't affect functionality

// Suppress ResizeObserver loop errors
const resizeObserverErrorHandler = (event) => {
  if (
    event.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    event.message === 'ResizeObserver loop limit exceeded'
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return false;
  }
};

// Add global error handler
if (typeof window !== 'undefined') {
  window.addEventListener('error', resizeObserverErrorHandler);
  
  // Also handle unhandled promise rejections that might contain ResizeObserver errors
  window.addEventListener('unhandledrejection', (event) => {
    if (
      event.reason?.message?.includes('ResizeObserver loop') ||
      event.reason?.toString?.()?.includes('ResizeObserver loop')
    ) {
      event.preventDefault();
      return false;
    }
  });
}

export default resizeObserverErrorHandler;